const ExtensionsContextParams = {
  scorecardId: {
    paramType: "number"
  },
  stepId: {
    paramType: "string"
  },
  controlVariantName: {
    paramType: "string"
  },
  treatmentVariantName: {
    paramType: "string"
  },
  startTime: {
    paramType: "string"
  },
  endTime: {
    paramType: "string"
  },
  nochrome: {
    paramType: "boolean"
  },
  rollupType: {
    paramType: "string"
  },
  metricName: {
    paramType: "string"
  },
  workspaceId: {
    paramType: "string"
  },
  analysisTemplate: {
    paramType: "string"
  },
  scorecardType: {
    paramType: "string"
  },
  primarySegmentName: {
    paramType: "string"
  },
  primarySegmentValue: {
    paramType: "string"
  },
  secondarySegmentName: {
    paramType: "string"
  },
  secondarySegmentValue: {
    paramType: "string"
  },
  layout: {
    paramType: "string"
  },
  treatmentAllocationId: {
    paramType: "string"
  },
  controlAllocationId: {
    paramType: "string"
  }
};
export {
  ExtensionsContextParams
};
//# sourceMappingURL=ExtensionsContext.js.map
